// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1Pgai","vLegacy":"SelectSecondary_vLegacy__IFrRs","error":"SelectSecondary_error__2DczH","disabled":"SelectSecondary_disabled__1SakU"};